<template>
    <section class="section">
        <b-row>
            <b-col>
                <b-card title="Log">
                    <div class="mt-4">
                        <vue-good-table
                            :columns="columns"
                            :rows="rows"
                            :sort-options="{
                                enabled: true,
                                initialSortBy: { field: 'timestamp', type: 'desc' }
                            }"
                            mode = "remote"
                            @on-page-change="onPageChange"
                            @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange"
                            :totalRows="totalRecords"
                            :pagination-options="{
                                enabled: true,
                                position: 'bottom',
                                perPageDropdown: [20, 50, 100],
                                dropdownAllowAll: true,
                                setCurrentPage: 1,
                                nextLabel: 'Successiva',
                                prevLabel: 'Precedente',
                                rowsPerPageLabel: 'Log per pagina',
                                ofLabel: 'of',
                                pageLabel: 'page', // for 'pages' mode
                                allLabel: 'tutti',
                            }"
                        />
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </section>
</template>

<script>

import api from '@/services/api';
import moment from 'moment';
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';

export default {
  components: { VueGoodTable },
    name: "Logs",
    data() {
        return {
            rows: [], 
            columns: [
                {
                    label: 'Operazione',
                    field: 'operation',
                    sortable: true,
                },
                {
                    label: 'Note',
                    field: 'notes',
                    sortable: true,
                },
                {
                    label: 'Data',
                    field: 'timestamp',
                    type: 'date',
                    dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss',
                    dateOutputFormat: 'dd/MM/yyyy HH:mm',
                    sortable: true,
                },
            ],
            operations: [],
            totalRecords: 0,
            page: 1, 
            itemsPerPage: 20,
        }
    },
    async created() {
        this.$store.commit("loading");
        await this.loadLogs();
        await this.loadLogOperations();
        this.$store.commit("stopLoading"); 
    },

    methods: {
        onSortChange(params) {
            if(params.length == 0) {
                return;
            }

            const param = params[0];
            let type = 1; // 1 = asc, -1 = desc

            if(param.type == "desc") {
                type = -1;
            }

            setTimeout(() => {
                this.rows = this.rows.sort((a, b) => {
                    if(a[param.field] > b[param.field]) {
                        return type;
                    }
                    return - type;
                });
            }, 100);
        },
        async onPageChange(params) {
            this.page = params.currentPage;
            await this.loadLogs();
        },
        async onPerPageChange(params) {
            this.page = 1;
            this.itemsPerPage = params.currentPerPage;
            await this.loadLogs();
        },
        async loadLogOperations() {
            const response = await api().get('/log-operations');
            this.operations = response.data.data;

            this.rows = this.rows.map(item => {
                const op = this.operations.find(op => op.operation == item.operation);
                item.operation = op.translate; // to sort on the string displayed
                return item;
            })
        },
        async loadLogs() {
            const response = await api().post('/logs', { page: this.page - 1, itemsPerPage: this.itemsPerPage });
            this.rows = response.data.data.logs;
            this.totalRecords = response.data.data.totalLogs;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Logs/Logs.vue